import React from 'react';
import classNames from 'classnames';

import {
  AcademyModuleTypeSelect,
  BatchModuleTypeSelect,
} from 'features/moduleManagement';
import AcademyModuleAsyncSelect from 'components/AcademyModuleAsyncSelect';
import styles from './AddSuperBatchModuleModalField.module.scss';
import Switch from 'components/Switch';

function AddSuperBatchModuleModalField({
  academyModule,
  academyModuleType,
  handleAcademyModuleChange,
  handleInterviewRequired,
  handleModuleTypeChange,
  handleOnChange,
  interviewRequired,
  moduleType,
  selectedModule,
  superBatch,
}) {
  return (
    <>
      <div className={styles.superbatch}>
        <span className="bold dark">Batch Name: </span>
        <span className="m-t-2">{superBatch?.name}</span>
      </div>
      <div className={styles.superbatch}>
        <span className="bold dark">Selected Module Name: </span>
        <span className="m-t-2">
          {selectedModule?.['academy_module']?.name}
        </span>
      </div>
      <div className={styles.toggle}>
        <span className="bold dark">Mock Interview: </span>
        <Switch
          checked={Boolean(interviewRequired)}
          onChange={handleInterviewRequired}
          className="m-l-xs"
          small
        />
        <span className="m-l-10">
          {Boolean(interviewRequired) ? '(Required)' : '(Not Required)'}
        </span>
      </div>
      <div className={styles.superbatch}>
        <span className="bold dark">
          Module To Add:<span className="danger">*</span>
        </span>
        <div className={styles.wrapper}>
          <div className={styles.selectWrapper}>
            <AcademyModuleTypeSelect
              value={moduleType}
              onChange={handleModuleTypeChange}
              className={classNames(styles.input, 'm-r-xs')}
            />
          </div>
          {moduleType && (
            <div className={styles.selectWrapper}>
              <AcademyModuleAsyncSelect
                category={moduleType?.value}
                value={academyModule}
                onChange={handleAcademyModuleChange}
              />
            </div>
          )}
        </div>
      </div>
      <div className={styles.superbatch}>
        <span className="bold dark">
          Module To Add Type(Elective/ Mandatory):
          <span className="danger">*</span>{' '}
        </span>
        <div className={styles.selectWrapper}>
          <BatchModuleTypeSelect
            value={{ value: academyModuleType, label: academyModuleType }}
            onChange={handleOnChange}
            placeholder="Select Academy Module Type"
          />
        </div>
      </div>
    </>
  );
}

export default AddSuperBatchModuleModalField;
